import { rem } from "polished";
import styled from "styled-components";

import { ColorLabels } from "@/components/editor/utils/use-color";

export const CenteredHeader = styled.div`
  margin-bottom: ${rem(40)};

  .text-primitive.headingTwo {
    text-align: center;
    color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY_FONT]};
  }
`;

export const SpeakerList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
